/* eslint-disable react/prop-types */
import React from 'react';

const ProductPlaceholder = ({ total = 3, containerStyle = {}, style = {} }) => {
  const productList = [];
  for (let i = 0; i < total; i++) {
    productList.push(i);
  }

  const isMoreThan = total > 3 ? 'xload-flex-container' : 'mainbody xload';

  return (
    <div className={isMoreThan}>
      {productList.map((item, index) => (
        <div key={item} className="xload-w-full xload-w-padding">
          <div className="xload-placeholder xload-radius xload-w-full xload-h-100"></div>
          <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
          <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
          <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
        </div>
      ))}
    </div>
  );
};

export default ProductPlaceholder;
